import React from "react";

const ToolCard = ({ name, IconComponent, color }) => {
    return (
        <div className="tool-card group flex flex-col items-center cursor-pointer">
            <div
                className="w-20 h-20 sm:w-24 sm:h-24 flex items-center justify-center rounded-xl bg-white border-2 border-[#111] text-4xl shadow-brutal-sm group-hover:bg-[#F2EFE9] transition-colors"
            >
                <IconComponent color={color} />
            </div>
            <p className="mt-3 text-[#111] text-xs font-bold tracking-wide text-center font-jakarta">
                {name}
            </p>
        </div>
    );
};

export default ToolCard;